import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div>
       <footer className="site-footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-4">
                <h2 className="footer-heading mb-4">About Us</h2>
                <p>
                  At Premium Car Rentals, we take pride in offering specialized
                  corporate car rental services to meet your every travel need.
                  Whether you prefer the freedom of self-drive, the luxury of
                  chauffeur-driven rides, or require a delegation car rental, we have
                  you covered.
                </p>
              </div>
              <div className="col-lg-8 ml-auto text-center">
                <div className="row">
                  <div className="col-lg-6">
                    <h2 className="footer-heading mb-4">Quick Links</h2>
                    <ul className="list-unstyled">
                      <li>
                        <Link className="text-white" to="/about">
                          About Us
                       </Link>
                      </li>
                      <li>
                        <Link className="text-white" to="/ourFleet">
                          Our Fleet
                       </Link>
                      </li>
                      <li>
                        <Link className="text-white" to="/ourServices">
                          {" "}
                          Service
                       </Link>
                      </li>
                      <li>
                        <Link className="text-white" to="/contact">
                          Contact Us
                       </Link>
                      </li>
                      <li>
                        <Link className="text-white" to="/policy">
                          Our Policy
                       </Link>
                      </li>
                      <li>
                        <Link className="text-white" to="/termcondition">
                          Terms &amp; Conditions
                       </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-6">
                    <h3 className="">Contact Info</h3>
                    <ul className="list-unstyled footer-link">
                      <li className=" mb-3">
                        <span className="fw-bold text-white">Address: </span>
                        <span className="text-white">
                          {" "}
                          Cardinal Rugambwa Social Center, Suit No. 09 Haile Selasie
                          Road, Oysterbay, P.O.Box 2340 Dar es Salaam, Tanzania.
                        </span>
                      </li>
                      <li className="mb-3">
                        <span className="fw-bold text-white">Phone:</span>
                        <span className="text-white"> +255 757 900007</span>
                      </li>
                      <li className=" mb-3">
                        <span className="fw-bold text-white">Email:</span>
                        <span className="text-white">
                          {" "}
                          office@premiumcarrentals.co.tz
                        </span>
                      </li>
                      <li className=" mb-3">
                        <span className="fw-bold text-white">Website:</span>
                        <span className="text-white">
                          {" "}
                          www.premiumcarrantals.co.tz{" "}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <p className="text-center">
                For inquiries and bookings, contact us call or WhatsApp at 0757900007.
              </p>
            </div>
            <div className="row pt-5 mt-5 text-center">
              <div className="col-md-12">
                <div className="border-top pt-5">
                  <p>Premium Car Rentals Limited – Elevate Your Travel Experience!</p>
                </div>
              </div>
            </div>
          </div>
        </footer>
    </div>
  )
}

export default Footer
